import { useContext } from "react";
import MyErrorBoundary from "../../utils/ErrorBoundary";
import { DesignAssetContext } from "../../pages/CustomHooks/ContextApi";
const LoadPvBess = ({ loadLength, configured, }) => {
    const {
        loadSelectHandler,
    } = useContext(DesignAssetContext);
    const totalCount =
        typeof loadLength === "object" && loadLength !== null ? loadLength.loadCount : loadLength || 0;


    return (
        <MyErrorBoundary>
            <>
                {
                    (
                        <svg
                            className="pointer"
                            x={0}
                            y={0}
                        >
                            <g id="CB1-load1">
                                <svg
                                    width="70px"
                                    height="103px"
                                    viewBox="0 0 10 149"
                                    x={45}
                                    y={0}
                                >
                                    <title>{"load Cb"}</title>
                                    <g
                                        id="Circuit Breaker"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                    >
                                        <g
                                            id="Circuit Breaker 1"
                                            transform="translate(-651.000000, -512.000000)"
                                        >
                                            <g
                                                id="Circuit Breaker - closed"
                                                transform="translate(604.000000, 514.000000)"
                                            >
                                                <g
                                                    id="Group-15"
                                                    strokeWidth="4"

                                                >
                                                    <rect
                                                        id="Rectangle-Copy-20"
                                                        x="4"
                                                        y="8"
                                                        width="96"
                                                        height="124"
                                                    ></rect>
                                                    <g
                                                        id="Group-2"
                                                        transform="translate(48.000000, 0.000000)"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                                                        strokeWidth="4"
                                                    >
                                                        <line
                                                            x1="0.5"
                                                            y1="12"
                                                            x2="0.5"
                                                            y2="47.8298611"
                                                            id="Line-2"
                                                        ></line>
                                                    </g>
                                                </g>
                                                <line
                                                    x1="48.5"
                                                    y1="97.1701389"
                                                    x2="48.501111"
                                                    y2="145"
                                                    id="Line-2-Copy-15"
                                                    stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                                                    strokeWidth="4"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                ></line>
                                                <path
                                                    d="M49,48.6645651 C56.9440104,64.554855 56.9440104,80.5555556 49,96.6666667"
                                                    id="Path-11"
                                                    stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                                                    strokeWidth="4"
                                                    strokeLinecap="round"
                                                ></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </g>
                            <g id="load1">
                                <svg
                                    x={0}
                                    y={20}
                                    width="149px"
                                    height="475px"
                                    viewBox="0 0 90 550"
                                    onClick={loadSelectHandler}

                                >
                                    <title>load</title>
                                    <g
                                        id="Design"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                    >
                                        <g
                                            id="Design/Assets-_-00"
                                            transform="translate(-604.000000, -372.000000)"
                                        >
                                            <g
                                                id="SLD/Production/Uniline/Undefined"
                                                transform="translate(604.000000, 372.000000)"
                                            >
                                                <g id="SLD/Production/Uniline/Tobedefine">
                                                    <g id="Group-7">
                                                        <rect
                                                            id="Rectangle"
                                                            x="0"
                                                            y="95"
                                                            width="96"
                                                            height="148"
                                                        ></rect>

                                                        <line
                                                            x1="48.5"
                                                            y1={"96"}
                                                            x2="48.5"
                                                            y2="144"
                                                            id="Line-2"
                                                            strokeWidth="3"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                                                        ></line>

                                                        <circle
                                                            id="Oval"
                                                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                                                            strokeWidth="3"
                                                            cx={"58"}
                                                            cy={"193.5"}
                                                            r="45"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            fill=""
                                                        ></circle>

                                                        {<circle
                                                            id="Oval"
                                                            strokeWidth="3"
                                                            fill="var(--se-background-alternative)"
                                                            cx="48"
                                                            cy="193.5"
                                                            r="46.5"
                                                            stroke={configured ? "var(--se-sld-circline)" : "#E47F00"}
                                                        ></circle>
                                                        }
                                                        <text
                                                            id="segment_energy_infra"
                                                            fontFamily="se-icon"
                                                            fontSize="56"
                                                            fontWeight="normal"
                                                            fill="var(--se-sld-circline)"
                                                        >
                                                            <tspan x="20" y="210">
                                                                segment_building_small
                                                            </tspan>
                                                        </text>
                                                    </g>
                                                    {<g
                                                        id="999🔒Atoms/Notifications/Done"
                                                        transform="translate(75.000000, 160.000000)"
                                                    >
                                                        <g
                                                            id="999🔒Atoms/Background/Round"
                                                            strokeWidth="1"
                                                            fillRule="evenodd"
                                                            fill={configured ? "var(--se-sld-circline)" : "#E47F00"}
                                                            stroke="var(--se-background-alternative)"
                                                        >
                                                            <circle
                                                                id="Oval"
                                                                strokeWidth="2.66666667"
                                                                cx="16"
                                                                cy="16"
                                                                r={loadLength?.loadCount > 9 ? "20" : "18"}
                                                            ></circle>
                                                        </g>

                                                        <text
                                                            id="3"
                                                            fontFamily="Nunito-Regular, Nunito"
                                                            fontSize="21"
                                                            fontWeight="normal"
                                                            fill="var(--se-background-alternative)"
                                                        >
                                                            <tspan
                                                                x={loadLength?.loadCount < 10 ? "8" : "5"}
                                                                y="24"
                                                            >
                                                                {totalCount}
                                                            </tspan>
                                                        </text>
                                                    </g>}
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </g>
                        </svg>
                    )}
            </>
        </MyErrorBoundary>
    );
};

export default LoadPvBess;
